// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"301":"bba4fd36","453":"26665d3b","980":"a90e4fc1"}[chunkId] + ".chunk.js";
};